import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { TAX_ESTIMATION: { VERSION, BASE } } } = USER;

export const useTaxEstimateDataQuery = ({ customerId }: { customerId: string }) => useQuery(
  'taxEstimateData',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`));
    return data;
  },
  {
    enabled: false,
  },
);
